import { useState, useEffect  } from "react";
import { useForm, Controller  } from "react-hook-form";
import { useSelector } from "react-redux";
import { useAddNewUserMutation } from "context/users/usersApiSlice";
import { selectCurrentUser } from "context/auth/authSlice";
import { useSignupMutation } from "context/auth/authApiSlice";
import { Link, useParams } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDInput from "dashboard/components/MDInput";
import MDButton from "dashboard/components/MDButton";
import MDAlert from "dashboard/components/MDAlert";
import MDTypography from "dashboard/components/MDTypography";
import { Icon, InputAdornment, LinearProgress, Divider } from "@mui/material";

import useAlert from "hooks/useAlert";
import useHelper from "hooks/useHelper";
import useGeolocation from "hooks/useGeolocation";

// Authentication layout components
export default  function RegisterForm() {

    const { isValidEmail, isValidName, isValidPass } = useHelper();
    const [showpassword, setShowPassword] = useState(true);
    const showPassword = () =>setShowPassword(!showpassword);
    const { getGeoLocationData, coordinates } = useGeolocation();
    const [geolocation, setGeolocation] = useState({});
    const {showAlerts} = useAlert();
    const connectedUser = useSelector(selectCurrentUser);
    const { type } = useParams();
    
    const { register, handleSubmit, control, reset, formState: { errors } } = useForm({
        defaultValues:{
            user:'',
            email:'',
            password : ''
    }});
    
    // setup login api 
    const loginState = {
        user:'Lastname Firstname and a space between',
        email:'a valid email adress is required',
        password : 'Minimum 8 characters, at least one capital letter, and one number'
    };
    const  [errorMsg, setErrorMsg] = useState("");

    const [userSignup, {isLoading}] = useSignupMutation();
    const [addNewUser, {isLoading : addLoading}] = useAddNewUserMutation();

    useEffect( async () => {
      
        const getUserGeolocation = await getGeoLocationData("fr");
        const userLoaction = { 
            country:  {
                name : getUserGeolocation.country,
                code : getUserGeolocation.countryCode,
                phone : getUserGeolocation.phone
            },
            state  : {
                province : getUserGeolocation?.regionName,
                code : getUserGeolocation?.region
            } 
        } 
        const userCordinate=  await coordinates();
        setGeolocation({
            ...userLoaction,
            coordinates    : userCordinate,
            street : ""
        });
    }, []);

    const onSubmit = async data =>{
        setErrorMsg('');
        data.location = geolocation;
        if(type) data.type = type;
        try{
            const userData = connectedUser ? await addNewUser(data).unwrap() : await userSignup(data).unwrap();
            showAlerts({code:"success", msg : userData.message , title: "User registration" ,type : "toast"});
            reset();
        }catch (err){
            setErrorMsg(err.data?.message);
        }
    }
  return (
    <MDBox component="form" sx={{ whiteSpace: "normal" }} role="form" onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="on">
        {( addLoading || isLoading) && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}
        <MDBox mb={2}>
            <Controller name="user" control={control} 
                render={({ field: { onChange, value } }) => (
                <MDInput   onChange={onChange}   value={value} type="text" label="Full name" required fullWidth 
                {...register("user", { required: loginState.user, validate: isValidName})}
                error={Boolean(errors.user)}
                helperText={errors.user?.message}
                />
                )}
            />
        </MDBox>
        <MDBox mb={2}>
            <Controller name="email" control={control} 
                render={({ field: { onChange, value } }) => (
                <MDInput   onChange={onChange}   value={value} type="email" label="Email" required fullWidth 
                {...register("email", { required: loginState.email, validate: isValidEmail })}
                error={Boolean(errors.email)}
                helperText={errors.email?.message} />
                )}
            />
        </MDBox>
        <MDBox mb={2}>
            <Controller name="password" control={control} 
                render={({ field: { onChange, value } }) => (
                <MDInput   onChange={onChange} value={value} type={showpassword ? "password" : "text"} label="Password" required fullWidth 
                    {...register("password", { required: loginState.password,validate : isValidPass })}
                    error={Boolean(errors.password)}
                    helperText={errors.password?.message} 
                    InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Icon sx={{ cursor:"pointer" }} fontSize="medium"  onClick={showPassword}>{showpassword ? "visibility" : "visibility_off"}</Icon>
                        </InputAdornment>
                    )}}
                    />
                )}
            />
        </MDBox>
        <MDBox mt={4} mb={1}>
        {errorMsg && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {errorMsg} </small></MDAlert> }
        </MDBox>
        <MDBox mt={4} mb={1}>
            <MDButton  variant="gradient" color="info" type="submit" fullWidth>
            Register
            </MDButton>
        </MDBox>
        <Divider />
				<MDBox mt={1} mb={1} sx={{textAlign:"center"}}>
					<MDTypography variant="button"  color="text">
						déjà inscrit ? {" "}
						<MDTypography
								component={Link}
								to="/authentication/sign-in"
								variant="button"
								color="info"
								fontWeight="medium"
								textGradient
							>
								Me connecter
							</MDTypography>
					</MDTypography>
				</MDBox>
    </MDBox>
  )
}
